<template>
  <material-card color="primary" title="View MM Query">
    <v-data-table
      :items="items"
      hide-actions
      :headers="[
        { text: 'Data', value: 'insert_at', sortable: false },
        { text: 'User', value: 'name', sortable: false },
        { text: 'Comment', value: 'comment', sortable: false },
        {
          text: 'AE verbatim reported',
          value: 'ae_verbatim_reported',
          sortable: false,
        },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ]"
    >
      <template slot="items" slot-scope="{ item }">
        <td>{{ formatDate(item.insert_at) }}</td>
        <td>{{ item.name }} {{ item.surname }}</td>
        <td>{{ item.comment }}</td>
        <td>{{ item.ae_verbatim_reported }}</td>
        <td>{{ item.status }}</td>
        <td>
          <v-tooltip top>
            <template slot="activator" slot-scope="{ on }">
              <a
                flat
                @click="$router.push('/adverse_event/' + item.adverse_event_id)"
                class="ml-2"
              >
                <v-icon v-on="on" color="primary">mdi-eye</v-icon>
              </a>
            </template>
            <span>View SAE</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
  </material-card>
</template>

<script>
import { getDetail } from "@/api/mm_query";
import moment from 'moment';

export default {
  inheritAttrs: false,
  props: {
    item: {},
    value: false,
  },
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      return getDetail(this.item.adverse_event_id).then((data) => {
        this.items = data;
      });
    },
    formatDate(x) {
      return moment(new Date(x)).format("DD-MMM-YYYY HH:mm:ss");
    },
  },
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
